exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".logo-big[data-v-0e5e48fe]{position:absolute;top:0}.logo-fake[data-v-0e5e48fe]{height:210px}.options[data-v-0e5e48fe]{font-size:12px;line-height:12px}.options--password[data-v-0e5e48fe]{display:inline-block;margin-bottom:12px}", ""]);
